export const formatDate = (
    dateString: string,
    options: Intl.DateTimeFormatOptions = {}
): string => {
    const date = new Date(dateString.replace(/-/g, '/'));
    return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        ...options,
    });
};

/** YYYY-MM-DD in the browser's timezone; toISOString() gives the UTC date, a day off around midnight. */
export const localDate = (date = new Date()): string =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

/** The YYYY-MM-DD date `days` after the YYYY-MM-DD date `base`. */
export const addDays = (base: string, days: number): string => {
    const date = new Date(`${base}T00:00`);
    date.setDate(date.getDate() + days);
    return localDate(date);
};

const LOCALSTORAGE_KEY = 'welcomeDialogDismissed';

export const isWelcomeDialogDismissed = () => {
    try {
        return localStorage.getItem(LOCALSTORAGE_KEY) === 'true';
    } catch (e) {
        return false;
    }
};

export const dismissWelcomeDialog = () => {
    localStorage.setItem(LOCALSTORAGE_KEY, 'true');
};

export const scroll = (element: HTMLElement | null): void => {
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};
